import { render, staticRenderFns } from "./MFM.vue?vue&type=template&id=1fed7ac3&scoped=true"
import script from "./MFM.vue?vue&type=script&lang=js"
export * from "./MFM.vue?vue&type=script&lang=js"
import style0 from "./MFM.vue?vue&type=style&index=0&id=1fed7ac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fed7ac3",
  null
  
)

export default component.exports